<template>
  <v-main class="main-container">
    <MyProfile />
  </v-main>
</template>
<script>
import MyProfile from "@/components/templates/MyProfile";

export default {
  components: { MyProfile },
};
</script>